// FIFA World Cup 2026 Stadium Data
export const STADIUMS = [
  {
    id: 'vancouver',
    name: 'BC Place',
    city: 'Vancouver',
    country: 'Canada',
    address: '777 Pacific Blvd, Vancouver (BC) V6B 4Y8, Canada',
    capacity: 48821,
    mapUrl: '/api/uploads/stadium_plans/vancouver.png',
    keywords: ['vancouver', 'bc place']
  },
  {
    id: 'toronto',
    name: 'BMO Field',
    city: 'Toronto',
    country: 'Canada',
    address: "170 Princes' Blvd, Toronto (ON) M6K 3C3, Canada",
    capacity: 44315,
    mapUrl: '/api/uploads/stadium_plans/toronto.png',
    keywords: ['toronto', 'bmo field']
  },
  {
    id: 'mexico_city',
    name: 'Estadio Azteca',
    city: 'Mexico City',
    country: 'Mexique',
    address: 'Calz. de Tlalpan 3465, Sta. Úrsula Coapa, Coyoacán, 04650 Ciudad de México, CDMX, Mexique',
    capacity: 72766,
    mapUrl: '/api/uploads/stadium_plans/mexico_city.png',
    keywords: ['azteca', 'mexico city', 'ciudad de mexico', 'cdmx', 'banorte']
  },
  {
    id: 'guadalajara',
    name: 'Estadio Akron',
    city: 'Guadalajara',
    country: 'Mexique',
    address: 'Circuito J.V.C. 2800, El Bajío, 45014 Zapopan, Jalisco, Mexique',
    capacity: 44330,
    mapUrl: '/api/uploads/stadium_plans/guadalajara.png',
    keywords: ['guadalajara', 'akron', 'zapopan']
  },
  {
    id: 'monterrey',
    name: 'Estadio BBVA',
    city: 'Monterrey',
    country: 'Mexique',
    address: 'Av. Pablo Livas 2011, colonia La Pastora, C.P. 67140, en Guadalupe, Nuevo León, Mexique',
    capacity: 50113,
    mapUrl: '/api/uploads/stadium_plans/monterrey.png',
    keywords: ['monterrey', 'bbva']
  },
  {
    id: 'atlanta',
    name: 'Mercedes-Benz Stadium',
    city: 'Atlanta',
    country: 'USA',
    address: '1 AMB Dr NW, Atlanta, GA 30313, États-Unis',
    capacity: 67382,
    mapUrl: '/api/uploads/stadium_plans/atlanta.png',
    keywords: ['atlanta', 'mercedes-benz']
  },
  {
    id: 'boston',
    name: 'Gillette Stadium',
    city: 'Boston',
    country: 'USA',
    address: '1 Patriot Pl, Foxborough, MA 02035, États-Unis',
    capacity: 63815,
    mapUrl: '/api/uploads/stadium_plans/boston.png',
    keywords: ['boston', 'gillette', 'foxborough']
  },
  {
    id: 'dallas',
    name: 'AT&T Stadium',
    city: 'Dallas',
    country: 'USA',
    address: '1 AT&T Way, Arlington, TX 76011, États-Unis',
    capacity: 70122,
    mapUrl: '/api/uploads/stadium_plans/dallas.png',
    keywords: ['dallas', 'at&t', 'arlington']
  },
  {
    id: 'houston',
    name: 'NRG Stadium',
    city: 'Houston',
    country: 'USA',
    address: 'NRG Pkwy, Houston, TX 77054, États-Unis',
    capacity: 68311,
    mapUrl: '/api/uploads/stadium_plans/houston.png',
    keywords: ['houston', 'nrg']
  },
  {
    id: 'kansas_city',
    name: 'Arrowhead Stadium',
    city: 'Kansas City',
    country: 'USA',
    address: '1 Arrowhead Dr, Kansas City, MO 64129, États-Unis',
    capacity: 67513,
    mapUrl: '/api/uploads/stadium_plans/kansas_city.png',
    keywords: ['kansas city', 'arrowhead']
  },
  {
    id: 'los_angeles',
    name: 'SoFi Stadium',
    city: 'Los Angeles',
    country: 'USA',
    address: '1001 Stadium Dr, Inglewood, CA 90301, États-Unis',
    capacity: 69650,
    mapUrl: '/api/uploads/stadium_plans/los_angeles.png',
    keywords: ['los angeles', 'sofi', 'inglewood']
  },
  {
    id: 'miami',
    name: 'Hard Rock Stadium',
    city: 'Miami',
    country: 'USA',
    address: '347 Don Shula Dr, Miami Gardens, FL 33056, États-Unis',
    capacity: 64091,
    mapUrl: '/api/uploads/stadium_plans/miami.png',
    keywords: ['miami', 'hard rock']
  },
  {
    id: 'new_york',
    name: 'MetLife Stadium',
    city: 'New York / New Jersey',
    country: 'USA',
    address: '1 MetLife Stadium Dr, East Rutherford, NJ 07073, États-Unis',
    capacity: 78576,
    mapUrl: '/api/uploads/stadium_plans/new_york.png',
    keywords: ['metlife', 'east rutherford', 'new jersey', 'new york']
  },
  {
    id: 'philadelphia',
    name: 'Lincoln Financial Field',
    city: 'Philadelphia',
    country: 'USA',
    address: 'One Lincoln Financial Field Way, Philadelphia, PA 19148, États-Unis',
    capacity: 65827,
    mapUrl: '/api/uploads/stadium_plans/philadelphia.png',
    keywords: ['philadelphia', 'philadelphie', 'lincoln financial']
  },
  {
    id: 'san_francisco',
    name: "Levi's Stadium",
    city: 'San Francisco Bay Area',
    country: 'USA',
    address: '4900 Marie P DeBartolo Way, Santa Clara, CA 95054, États-Unis',
    capacity: 69391,
    mapUrl: '/api/uploads/stadium_plans/san_francisco.png',
    keywords: ['san francisco', 'santa clara', "levi's", 'levis stadium', 'bay area']
  },
  {
    id: 'seattle',
    name: 'Lumen Field',
    city: 'Seattle',
    country: 'USA',
    address: '800 Occidental Ave S, Seattle, WA 98134, États-Unis',
    capacity: 65123,
    mapUrl: '/api/uploads/stadium_plans/seattle.png',
    keywords: ['seattle', 'lumen field']
  }
];

// FIFA World Cup 2026 - Official mapping match number → stadium id
// Source: FIFA official schedule
export const WC_MATCH_TO_STADIUM = {
  1: 'mexico_city', 2: 'guadalajara', 3: 'toronto', 4: 'los_angeles',
  5: 'boston', 6: 'vancouver', 7: 'new_york', 8: 'san_francisco',
  9: 'philadelphia', 10: 'houston', 11: 'dallas', 12: 'monterrey',
  13: 'miami', 14: 'atlanta', 15: 'los_angeles', 16: 'seattle',
  17: 'new_york', 18: 'boston', 19: 'kansas_city', 20: 'san_francisco',
  21: 'toronto', 22: 'dallas', 23: 'houston', 24: 'mexico_city',
  25: 'atlanta', 26: 'los_angeles', 27: 'vancouver', 28: 'guadalajara',
  29: 'philadelphia', 30: 'boston', 31: 'san_francisco', 32: 'seattle',
  33: 'toronto', 34: 'kansas_city', 35: 'houston', 36: 'monterrey',
  37: 'miami', 38: 'atlanta', 39: 'los_angeles', 40: 'vancouver',
  41: 'new_york', 42: 'philadelphia', 43: 'dallas', 44: 'san_francisco',
  45: 'boston', 46: 'toronto', 47: 'houston', 48: 'guadalajara',
  49: 'miami', 50: 'atlanta', 51: 'vancouver', 52: 'seattle',
  53: 'mexico_city', 54: 'monterrey', 55: 'philadelphia', 56: 'new_york',
  57: 'dallas', 58: 'kansas_city', 59: 'los_angeles', 60: 'san_francisco',
  61: 'boston', 62: 'toronto', 63: 'seattle', 64: 'vancouver',
  65: 'houston', 66: 'guadalajara', 67: 'new_york', 68: 'philadelphia',
  69: 'kansas_city', 70: 'dallas', 71: 'miami', 72: 'atlanta',
  73: 'los_angeles', 74: 'boston', 75: 'monterrey', 76: 'houston',
  77: 'new_york', 78: 'dallas', 79: 'mexico_city', 80: 'atlanta',
  81: 'san_francisco', 82: 'seattle', 83: 'toronto', 84: 'los_angeles',
  85: 'vancouver', 86: 'miami', 87: 'kansas_city', 88: 'dallas',
  89: 'philadelphia', 90: 'houston', 91: 'new_york', 92: 'mexico_city',
  93: 'dallas', 94: 'seattle', 95: 'atlanta', 96: 'vancouver',
  97: 'boston', 98: 'los_angeles', 99: 'miami', 100: 'kansas_city',
  101: 'dallas', 102: 'atlanta', 103: 'miami', 104: 'new_york',
};

// Extract match number from event string (e.g., "M8 Qatar vs Switzerland..." → 8)
const extractMatchNum = (str) => {
  if (!str) return null;
  const m = String(str).match(/\bM(\d{1,3})\b/i);
  if (!m) return null;
  const n = parseInt(m[1], 10);
  return n >= 1 && n <= 104 ? n : null;
};

// Find stadium by venue/city name, with optional match number override (FIFA WC priority)
// project: si fourni et != WORLD CUP, on désactive le mapping FIFA M{N} qui sinon fausse RG/PSG/etc.
export const findStadium = (lieu, ville, evenement, project) => {
  const isWorldCupProject = !project || String(project).toUpperCase().startsWith('WORLD CUP');

  // PRIORITY 1: Only apply FIFA WC match → stadium mapping for the WORLD CUP project.
  if (isWorldCupProject) {
    const matchNum = extractMatchNum(evenement);
    if (matchNum && WC_MATCH_TO_STADIUM[matchNum]) {
      const stadiumId = WC_MATCH_TO_STADIUM[matchNum];
      const stadium = STADIUMS.find(s => s.id === stadiumId);
      if (stadium) return { ...stadium };
    }
  }

  // PRIORITY 2: Fallback to keyword/city matching for non-WC events
  const searchText = `${lieu || ''} ${ville || ''}`.toLowerCase();
  if (!searchText.trim()) return null;

  for (const stadium of STADIUMS) {
    for (const keyword of stadium.keywords) {
      if (searchText.includes(keyword.toLowerCase())) {
        return { ...stadium };
      }
    }
    if (searchText.includes(stadium.city.toLowerCase())) {
      return { ...stadium };
    }
  }
  
  return null;
};

// Apply custom plans overrides
export const applyCustomPlans = (customPlans) => {
  if (!customPlans) return;
  for (const stadium of STADIUMS) {
    if (customPlans[stadium.id]) {
      stadium.mapUrl = customPlans[stadium.id];
    }
  }
};

export default STADIUMS;
